<div id="custom-top-banner" class="top-banner-wrapper" [style.top.px]="top">
  <div class="top-banner-list" *ngIf="notifications.length > 0">
    <div
      class="fmc-top-banner"
      *ngFor="let notification of notifications; index as i"
      [ngClass]="severityClass(notification.severity)"
      role="alert"
      aria-live="assertive"
    >
      <div class="fmc-top-banner__inner">
        <div class="fmc-top-banner__content">{{ notification.text }}</div>

        <a
          *ngIf="notification.link && notification.ctaLabel"
          class="fmc-top-banner__link"
          [href]="notification.link"
          rel="noopener noreferrer"
        >
          {{ notification.ctaLabel }}
        </a>

        <button
          *ngIf="notification.dismissable !== false"
          class="fmc-top-banner__close"
          type="button"
          aria-label="Close notification"
          (click)="hideBar(i)"
        >
          x
        </button>
      </div>
    </div>
  </div>
</div>
